<template>
    <div>
        <h1 class="mb-3"><span class="text-blue">Pemilu dan</span> <span class="text-red">Pilkada</span></h1>
        <div class="statusData mb-3">
            <div class="status card">
                <div class="flex">
                    <div class="text-bold">Nama</div>
                    <div>Donny Feerdiansyah</div>
                </div>
                <div class="flex">
                    <div class="text-bold">Status</div>
                    <div>Belum terdaftar sebagai saksi</div>
                </div>
                <div class="flex">
                    <div class="text-bold">TPS ID</div>
                    <div>-</div>
                </div>
            </div>
            <div class="card pengajuan text-center ">
                <div><i class="fas fa-book-reader"></i></div>
                <div>Mengajukan Diri Sebagai Saksi</div>
            </div>
        </div>
        <div class="text-red text-bold text-heading mb-2">Riwayat Pengajuan</div>
        <div class="tables">
            <tables>
                <template v-slot:first> No.</template>
                <template v-slot:second> Details </template>
                <template v-slot:third>Tanggal Mengajukan </template>
                <template v-slot:fourth>Status</template>
            </tables>
        </div>
        <div class="listPengajuan">
            <div class="card">
                <div>Detail Pengajuan</div>
                <div class="text-bold">Saksi Daerah Kota Bandung</div>
                <div>Tanggal Mengajukan</div>
                <div class="text-bold">10 Juni 2021</div>
                <div>Status</div>
                <div class="text-bold">Ditolak</div>
            </div>
            <div class="card">
                <div>Detail Pengajuan</div>
                <div class="text-bold">Saksi Daerah Kota Bandung</div>
                <div>Tanggal Mengajukan</div>
                <div class="text-bold">10 Juni 2021</div>
                <div>Status</div>
                <div class="text-bold">Ditolak</div>
            </div>
            <div class="card">
                <div>Detail Pengajuan</div>
                <div class="text-bold">Saksi Daerah Kota Bandung</div>
                <div>Tanggal Mengajukan</div>
                <div class="text-bold">10 Juni 2021</div>
                <div>Status</div>
                <div class="text-bold">Ditolak</div>
            </div>
            <div class="card">
                <div>Detail Pengajuan</div>
                <div class="text-bold">Saksi Daerah Kota Bandung</div>
                <div>Tanggal Mengajukan</div>
                <div class="text-bold">10 Juni 2021</div>
                <div>Status</div>
                <div class="text-bold">Ditolak</div>
            </div>
               <button class="btnSelengkapnya">Lihat Lebih Banyak <i class="fas fa-chevron-down"></i></button>
        </div>
    </div>
</template>

<script>
import tables from '../../components/table.vue'
export default {
  components: {
    tables
  }
}
</script>

<style lang="scss" scoped>
    h1 {
        @media only screen and (max-width: 600px) {
            font-size: 16px;
            margin-bottom: 2rem !important;
            margin-top: 2rem;
        }
    }

    .statusData {
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-gap: 1rem;

        @media only screen and (max-width: 600px) {
            grid-template-columns: 1fr;
        }

        .card {
            padding: 20px 1rem;
            box-shadow: 0 1.1px 11.1px 0 rgba(33, 64, 154, 0.04), 0 9px 89px 0 rgba(33, 64, 154, 0.07);

            .flex {
                .text-bold {
                    @media only screen and (max-width: 600px) {
                        margin-right: 1rem;
                    }
                }

            }

            &.pengajuan {
                background-color: $blue;
                color: #fff;

                @media only screen and (max-width: 600px) {
                    display: flex;
                    align-items: center;
                    padding: 0 1rem;
                    justify-content: center;
                }

                i {
                    font-size: 20px;
                    margin-bottom: 1rem;
                    margin-top: 10px;

                    @media only screen and (max-width: 600px) {
                        margin-right: 1rem;
                    }
                }
            }
        }

        .status {
            line-height: 2;

            .text-bold {
                width: 15%;
            }
        }
    }

    .btnSelengkapnya{
        display: none;
          @media only screen and (max-width: 600px) {
            display: block;
        }
    }

</style>
